/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon20Solid = forwardRef('GovKoSfrIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.93 1.47a1.25 1.25 0 0 1 .321 1.738l-1.718 2.5a1.25 1.25 0 0 1-1.03.542H6a2.75 2.75 0 0 0 0 5.5h.538l4.91-6.981a2.398 2.398 0 0 1 1.96-1.019H14a5.25 5.25 0 1 1 0 10.5h-1.835l-2.66 3.948a1.25 1.25 0 1 1-2.073-1.396l3.031-4.5a1.25 1.25 0 0 1 1.037-.552H14a2.75 2.75 0 1 0 0-5.5h-.538l-4.91 6.981a2.398 2.398 0 0 1-1.96 1.019H6a5.25 5.25 0 0 1 0-10.5h1.845l1.346-1.958a1.25 1.25 0 0 1 1.738-.322Z" })));
});
